console.log(">> RKN tracking is active")

async function trackKlaviyoCartUpdate() {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed with status: ${response.status}`);
    }

    const cart = await response.json();

    if (!cart || cart.item_count === 0) {
      console.log('Cart is empty. Skipping Klaviyo tracking.');
      return;
    }

    const domain = window.location.origin;

    const allCollectionsInCart = new Set()

    const items = cart.items.map(item => {
      
      const correspondingLineItemCollections = JSON.parse(document.querySelector(`*[data-item-id='${item.id}']`).dataset.itemCollections)

      // push all the collections in set 
      correspondingLineItemCollections.forEach(collection => allCollectionsInCart.add(collection))

      return ({
        'Product name': item.title,
        'ImageURL': item.image,
        'ItemPrice': parseFloat((item.price / 100).toFixed(2)), // Fixed
        'Checkout URL': `${domain}/cart/${item.id}:${item.quantity}`,
        'Collections': correspondingLineItemCollections.join("|")
      })
        
    });


    const payload = {
      $value: parseFloat((cart.total_price / 100).toFixed(2)), // Fixed
      ItemNames: cart.items.map(item => item.product_title),
      Items: items,
      CollectionsInCart: [...allCollectionsInCart],
    };

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Cart Updated', payload]);

    console.log('>> Klaviyo "Cart Updated" event tracked');
    console.log('>> Payload: ', payload )

  } catch (error) {
    console.error('Error tracking Klaviyo cart update:', error);
  }
}

document.addEventListener('theme:cart:change', () => {
  console.log("sent data to klaviyo")
  setTimeout(trackKlaviyoCartUpdate, 500);
});
